<script>
    import {getContext} from 'svelte';
    import SortIndicator from './SortIndicator.svelte';

    export let id;
    export let key;
    export let colspan;
    export let rowspan;
    export let headers;
    export let width;
    export let isHeader = false;
    export let sortable = false;
    export let reverse = false;

    const {sort} = getContext('sortable');

    let style = null;
    if (width) {
        style = `width: ${width}`;
    }

    let sort_direction = 'ascending';

    function handleSort(event){
        sort_direction = event.detail.direction;
        sort(key, sort_direction);
    }

</script>

<style>
    .header-col {
        display: flex;
        justify-content: space-between;
    }

</style>
{#if isHeader}
    <th {id} {colspan} {rowspan} {headers} {style}>
        <div class="header-col">
            <slot></slot>
            {#if sortable}
                <SortIndicator on:sort={handleSort} {reverse}/>
            {/if}
        </div>
    </th>
{:else}
    <td {id} {colspan} {rowspan} {headers} {style}>
        <slot></slot>
    </td>
{/if}
